/**
 * @generated SignedSource<<8e19cf9e3e6348266d48c0dafa0666c3>>
 * @lightSyntaxTransform
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dxid",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserLoggedInButtons_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "embed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ToolWorkflow",
      "kind": "LinkedField",
      "name": "workflows",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "toolProject",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*:: as any*/)
              ],
              "type": "ToolProject",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Tool",
      "abstractKey": null
    }
  ],
  "type": "ToolInterface",
  "abstractKey": "__isToolInterface"
};
})();

node.hash = "d05450cfdb86cb8fa57415d53b4d2068";

export default node;
